import { Button } from "shared-components";

import Image from "next/image";
import Link from "next/link";

import type { JSX } from "react";

/** Banner de chamada para customização na home: cartão glassmorphism com glows suaves, texto + CTA e a arte de produtos customizados. */
export const HomeCustomizeBanner = (): JSX.Element => {
  return (
    <div className="relative w-full overflow-x-clip px-page-x-margin py-10 lg:py-20">
      {/* Glows da seção: ficam na página, atrás do cartão de vidro, e extravasam as bordas dele */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-x-clip">
        <div className="absolute -left-[20%] top-[0%] h-[260px] w-[220px] rounded-full bg-brand-yellow opacity-45 blur-[60px] lg:left-[8%] lg:top-[10%] lg:h-[360px] lg:w-[420px] lg:blur-[90px]" />
        <div className="absolute -right-[15%] bottom-[0%] h-[260px] w-[220px] rounded-full bg-[#E6007E] opacity-30 blur-[60px] lg:right-[6%] lg:bottom-[5%] lg:h-[400px] lg:w-[400px] lg:blur-[90px]" />
        <div className="absolute -right-[15%] top-[15%] h-[220px] w-[200px] rounded-full bg-[#9B7BE8] opacity-30 blur-[60px] lg:right-[28%] lg:top-[0%] lg:h-[320px] lg:w-[320px] lg:blur-[90px]" />
      </div>

      <div
        className={
          "relative mx-auto flex w-full max-w-page-max-width flex-col items-center gap-6 " +
          "rounded-[1.75rem] bg-white/55 p-6 shadow-[0_20px_50px_rgba(10,10,10,0.08),inset_0_1px_0_rgba(255,255,255,0.9)] backdrop-blur-[24px] " +
          "lg:flex-row lg:justify-between lg:gap-10 lg:rounded-[2rem] lg:px-16 lg:py-14 lg:px-12"
        }
      >
        <Image
          src="/images/home/customizar.png"
          alt="Exemplos de estampas em produtos personalizados"
          width={764}
          height={718}
          sizes="(min-width: 1024px) 28rem, 17rem"
          className="relative h-auto w-[17rem] shrink-0 lg:w-[min(32vw,28rem)]"
        />

        <div className="relative flex w-full flex-col lg:max-w-[35rem]">
          <h3 className="!font-medium text-xl lg:!text-5xl">
            Estampas com a sua cara, em camisetas feitas sob demanda pra você.
          </h3>

          <p className="mb-3 lg:mb-6 mt-1 lg:mt-3 text-base-gray lg:text-lg">
            Personalize do seu jeito e receba seu produto exclusivo no conforto da sua casa.
          </p>

          <Link href="/customizar-produto" className="w-full lg:w-fit">
            <Button rounded className="!bg-black !text-base-white px-6 lg:px-8 hover:!bg-black/80">
              Quero customizar
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
